<template>
  <div>
    <template v-if="is_detail_page">
      <v-btn
        v-if="!check_in_cart1(product)"
        depressed
        color="accent darken-4"
        @click="add"
        :disabled="disabled"
      >
        <slot name="add-cart-text">
          <div
            v-if="!in_not_desktop"
            :class="$style.btn"
          >
            <v-icon>mdi-cart-outline</v-icon>
            В корзину
          </div>
          <div v-else>
            <v-icon small>mdi-cart-outline</v-icon>
          </div>
        </slot>
      </v-btn>
      <template v-else>
        <v-btn
          depressed
          color="accent darken-4"
          :to="go_to_cart"
          :disabled="disabled"
        >
          <slot name="in-cart-text">
            <div :class="$style.btn">
              <v-icon>mdi-cart-arrow-right</v-icon>
              Перейти <br> в корзину
            </div>
          </slot>
        </v-btn>
      </template>
    </template>
    <template v-else>
      <v-btn
        v-if="!check_in_cart1(product)"
        icon
        color="accent darken-4"
        @click="add"
        :disabled="disabled"
      >
        <slot name="add-cart-text">
          <div v-if="!in_not_desktop">
            <v-icon>mdi-cart-outline</v-icon>
          </div>
          <div v-else>
            <v-icon small>mdi-cart-outline</v-icon>
          </div>
        </slot>
      </v-btn>
      <template v-else>
        <v-btn
          icon
          color="accent darken-4"
          :to="go_to_cart"
          :disabled="disabled"
        >
          <slot name="in-cart-text">
            <v-icon>mdi-cart-arrow-right</v-icon>
          </slot>
        </v-btn>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { check_item_in_cart1 } from '@/modules/cart/shared/services';
import { SharedCartPages } from '@/modules/cart/shared/types';
import { global_store } from '@/store';
import { Products } from '@/modules/products/types';
import CatalogProductItem = Products.CatalogProductItem;

@Component
export default class CatalogCartBtn extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  product!: CatalogProductItem;

  @Prop({ type: Boolean, default: false })
  disabled?: boolean;

  @Emit()
  add() {
    return true;
  }

  get go_to_cart() {
    return { name: SharedCartPages.CART };
  }

  get in_not_desktop() {
    return global_store.state.isTablet || global_store.state.isMobile;
  }

  get is_detail_page() {
    return this.$route.name === Products.Pages.PRODUCT_DETAIL;
  }

  check_in_cart1 = check_item_in_cart1;
}
</script>

<style module lang="scss">
  .btn {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
</style>
